import { render, staticRenderFns } from "./FForm.vue?vue&type=template&id=610aee82&"
import script from "./FForm.vue?vue&type=script&lang=js&"
export * from "./FForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports